import angular from 'angular';
import { throttle } from 'lodash';

module.exports = angular.module('market.directives.od-scroll-enter', [])
.directive('odScrollEnter', function($window, $document, $animate, $timeout) {
  let scrollY = function() { return $window.pageYOffset; };

  // IE support
  if ($window.pageYOffset === undefined) {
    scrollY = function() {
      return ($document.documentElement || $document.body).scrollTop;
    };
  }

  return {
    restrict: 'A',
    link: function(scope, element) {
      let top;
      const throttledCalculateTop = throttle(calculateTop, 100, { leading: false });
      const throttledScroll = throttle(onScroll, 100, { leading: false });
      const viewport = angular.element($window);

      $timeout(calculateTop);
      $timeout(onScroll);

      viewport.on('resize', throttledCalculateTop);
      viewport.on('scroll', throttledScroll);
      scope.$on('$destroy', function() {
        viewport.off('resize', throttledCalculateTop);
        viewport.off('scroll', throttledScroll);
      });

      function calculateTop() {
        const offsetTopRelativeToBody = element[0].getBoundingClientRect().top + scrollY();
        top = offsetTopRelativeToBody + element.css('paddingTop');
      }

      function onScroll() {
        if (scrollY() + $window.innerHeight > top) {
          angular.element($window).off('scroll', throttledScroll);
          $animate.addClass(element, 'scrolled');
          if (!scope.$$phase)
            scope.$digest();
        }
      }
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/directives/od-scroll-enter.js
 **/